import Vue from 'vue';
import Vuex from 'vuex';
import createCache from 'vuex-cache';

Vue.use(Vuex);

import snackbar from './modules/snackbar';
import localization from './modules/localization';
import auth from './modules/auth';
import user from './../modules/users/store';
import role from './modules/role';

import building from './../modules/buildings/store';
import person from './../modules/persons/store';

import building_complex from './../modules/building_complexes/store';
import apartment from './modules/apartment';
import document from './modules/document';
import person_request from './modules/person_request';
import app_layout from './modules/app_layout';
import item from './modules/item';
import inhabitant from './modules/inhabitant';
import region from './modules/region';

import statistic from './../modules/statistic/store';
import tag from './../modules/tags/store';
import form from './../modules/forms/form';
import notification from './../modules/notifications/store';
import appcontent from './../modules/app_content/appcontent';
import service from './../modules/services/store';
import order from './../modules/orders/store';
import subscription from './../modules/subscriptions/store';

import apps from '@/modules/apps/store/apps.js';
import communication_options from '@/modules/communication_options/store/communication_options.js';
import icons from './../modules/_global/_components/icon_select/store';
import phone_flags from './../modules/_global/_components/phone/store';
import posts from './../modules/posts/store';
import report from './../modules/reports/store';
import tile from './../modules/tiles/store';
import employee from './../modules/employees/store';
import task from './../modules/tasks/store';
import ereporter from './../modules/ereporter/store';
import booking_resources from './../modules/booking_resources/store';
import booking_schedule from './../modules/booking_schedule/store';
import booking_reservations from './../modules/booking_reservations/store';
import planning from './../modules/plannings/store';
import orders_opened from './../modules/orders_opened_badge/store';
import reservations_new_status_badge from '@/modules/reservations_new_status_chip/store';
import contact_person from './../modules/contact_persons/store';
import company from './../modules/companies/store';
import inhabitant_changes from './../modules/inhabitant_changes/store';
import new_inhabitant_changes from './../modules/inhabitant_change_badge/store';
import smarthome from './../modules/smarthome/store';
import abo_services from './../modules/abo_services/store';
import holidays from './../modules/holidays/store';
import contracts from './../modules/building_complexes_contracts/store';
import relation from './../modules/relations/store';
import documents_links from './../modules/documents_links/store';
import documents_lists from './../modules/documents_lists/store';
import request_vacations from './../modules/request_vacations/store';
import warehouse_devices from './../modules/devices/Warehouse/store';
import devices from './../modules/devices/Device/store';

export default new Vuex.Store({
  // `strict` means that we can't modify state directly (only through the mutations)
  strict: true,

  plugins: [
    createCache({ timeout: 1000 * 60 * 10 }) // 10 min
  ],

  state: {
    loading: true
  },

  getters: {
    loading: state => state.loading
  },

  mutations: {
    loading: (state, status) => {
      state.loading = status;
    }
  },

  modules: {
    localization,
    snackbar,
    auth,
    user,
    role,
    person,
    company,
    building,
    building_complex,
    apartment,
    service,
    subscription,
    document,
    person_request,
    relation,
    app_layout,
    contact_person,
    item,
    inhabitant,
    statistic,
    tag,
    form,
    notification,
    apps,
    appcontent,
    report,
    tile,
    communication_options,
    order,
    employee,
    posts,
    planning,
    ereporter,
    task,
    icons,
    phone_flags,
    region,
    booking_resources,
    booking_schedule,
    booking_reservations,
    orders_opened,
    reservations_new_status_badge,
    inhabitant_changes,
    new_inhabitant_changes,
    smarthome,
    abo_services,
    documents_links,
    documents_lists,
    holidays,
    contracts,
    warehouse_devices,
    devices,
    request_vacations
  }
});
